<template>
  <main class="main page-inside products-page categories-page">
    <div class="main-wrapper">
      <div class="section page-top-section">
        <div class="wrapper">
          <div class="title title-96">SHOP</div>
          <img src="./../images/crew.webp" class="img" />
        </div>
      </div>
      <div class="section page-body-section">
        <div class="circle"></div>
        <img src="./../images/squares.webp" class="squares" />
        <div class="title title-64">{{ $t("Products") }}</div>
        <div class="wrapper">
          <transition name="fade">
            <div class="list products" v-if="$parent.categories">
              <button
                class="item"
                v-for="(item, i) in $parent.categories"
                :key="i"
                @click="$emit('chooseCategoty', item)"
              >
                <div class="item-wrapper">
                  <div class="preview">
                    <img :src="imgDomain + item.image_url" class="img" />
                  </div>
                  <div class="desc regular">
                    {{ $t(item.title) }}
                  </div>
                </div>
              </button>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "Categories",
  props: [],
  components: {},
  data: function () {
    return {
      imgDomain: "",
    };
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
  },
  methods: {},
};
</script>
